//client/src/components/contratos/FiltroContratos.js
import React, { useState } from 'react';
import { useTiposContratoAtivos } from '../../hooks/useTiposContrato'; // ✅ HOOK CORRETO
import { Search, XCircle as ClearIcon, Loader2 } from 'lucide-react';

const FiltroContratos = ({ onFilterSubmit, loading }) => {
    // ✅ BUSCA APENAS TIPOS ATIVOS
    const { data: tiposContrato = [] } = useTiposContratoAtivos();
    
    const initialFilters = {
        numeroContrato: '',
        clienteNome: '',
        tipoContrato: ''
    };
    const [localFilters, setLocalFilters] = useState(initialFilters);

    const onChange = e => setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });

    const onSubmit = e => {
        e.preventDefault();
        const activeFilters = Object.fromEntries(
            Object.entries(localFilters).filter(([_, v]) => v !== '' && v !== null)
        );
        onFilterSubmit(activeFilters);
    };
    
    const handleClear = () => {
        setLocalFilters(initialFilters);
        onFilterSubmit({});
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <div className="form-grid-container">
                <div className="form-group">
                    <label htmlFor="f-numero">Nº do Contrato</label>
                    <input id="f-numero" type="text" name="numeroContrato" value={localFilters.numeroContrato || ''} onChange={onChange} className="form-input"/>
                </div>
                <div className="form-group">
                    <label htmlFor="f-cliente">Nome do Cliente</label>
                    <input id="f-cliente" type="text" name="clienteNome" value={localFilters.clienteNome || ''} onChange={onChange} className="form-input"/>
                </div>
                <div className="form-group">
                    <label htmlFor="f-tipo">Tipo de Contrato</label>
                    <select id="f-tipo" name="tipoContrato" value={localFilters.tipoContrato || ''} onChange={onChange} className="form-input">
                        <option value="">Todos</option>
                        {tiposContrato.map(t=><option key={t._id} value={t._id}>{t.nome}</option>)}
                    </select>
                </div>
            </div>
            <div className="form-actions">
                <button type="button" onClick={handleClear} className="action-button action-button-secondary">
                    <ClearIcon size={18} className="icon"/>Limpar Filtros
                </button>
                <button type="submit" className="action-button action-button-primary" disabled={loading}>
                    {loading ? <Loader2 className="animate-spin icon"/> : <Search size={18} className="icon" />}
                    Buscar
                </button>
            </div>
        </form>
    );
};

export default FiltroContratos;